export default __webpack_public_path__ + "static/media/whatWeDoImage.8720f192.png";